export default "__VITE_ASSET__c304578c__"